import React from "react";
import { showErrorDialog } from "./DialogViewport";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error(error);
    showErrorDialog(error?.message || "The admin panel ran into an unexpected issue. Refresh and try again.");
  }

  render() {
    if (this.state.hasError) {
      return (
        <main className="login-shell">
          <section className="login-panel">
            <p className="login-error">The admin panel ran into an unexpected issue. Refresh and try again.</p>
          </section>
        </main>
      );
    }

    return this.props.children;
  }
}
